import * as React from 'react';
export const chevronLeftSvg = React.forwardRef(function chevronLeftSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.666.606a.75.75 0 0 0-1.06-.022l-3 2.875a.75.75 0 0 0 0 1.082L4.6 7.416a.75.75 0 1 0 1.038-1.082L3.21 4l2.435-2.334a.75.75 0 0 0 .022-1.06Z',
    }),
  );
});
chevronLeftSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronLeft = {
  category: 'icon',
  colorable: true,
  name: 'chevronLeft',
  svg: chevronLeftSvg,
};
